import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { fetchMealItems, selectMealItems } from "../features/nutrition/meal-items/meal-item.slice";

const useMealItems = () => {
    const dispatch = useAppDispatch();
    const mealItems = useAppSelector(selectMealItems);

    const getMealItems = async () => {
        await dispatch(fetchMealItems({searchTerm: '', category: ''}));
    }

    useEffect(() => {
        if (mealItems.length === 0) {
            getMealItems();
        }
    }, []);

    return [mealItems];
}
 
export default useMealItems;